import api from "../../../../../../utils/api";

export const finishSubscription = async () => {
    let {data} = await api.get('/organizations/subscription/finalized')
    return data
}